/*eslint-disable*/
import React, { PureComponent } from 'react';

import './footer.styl';
import logo from '../../public/images/iw-logo.svg';
import * as AppActions from '../../modules/App/AppState';

class Footer extends PureComponent {
  onInfoClick = (evt) => {
    evt.preventDefault();
    this.props.dispatch(AppActions.setInfoboxMode('info'));
    _paq.push(['trackEvent', 'click_link', 'info', 'Schichtwechsel in Europa']);

    window.scrollTo(0, 0);
  }

  render() {
    const bgImage = { backgroundImage: `url(${logo})` };
    const studyLink = this.props.currentLanguage === 'de' ?
      'https://www.iwkoeln.de/einkommen-in-europa' :
      'https://www.iwkoeln.de/en/prosperity-in-europe';

    return (
      <div className="ifdw-footer">
        <div className="ifdw-footer--inner-wrapper left">
          <a href="http://www.iwkoeln.de" target="_blank" className="ifdw-footer--logo" style={bgImage} />
        </div>
        <div className="ifdw-footer--inner-wrapper right">
          <div>{this.props.translate('footer.studyPre')} <a href={studyLink} target="_blank" className="ifdw-footer--link" rel="noopener noreferrer">{this.props.translate('footer.study')}</a></div>
          <div className="ifdw-footer--faq">
            {this.props.translate('footer.definition')} <a className="ifdw-footer--link" onClick={this.onInfoClick} role="button" tabIndex="0">Info</a>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js